var map = {
	"./black.png": 59130,
	"./clubList.png": 63452,
	"./dragons.jpg": 5033,
	"./dragons.png": 96958,
	"./event_banner_temp.png": 86428,
	"./fansList.png": 39172,
	"./jdfc_2025_gameschedule.png": 42061,
	"./jdfc_seasontikcet_poster_2025.png": 38939,
	"./jdfc_temp_poster.jpeg": 28969,
	"./jdfc_temp_poster_2.jpeg": 84598,
	"./matchList.png": 27104,
	"./match_detail.png": 70915,
	"./playerList.png": 14193,
	"./ticketList.png": 78317,
	"./ticket_info.png": 86152,
	"./youthList.png": 97307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13554;